import React, { useContext, useState } from "react";
import { Request } from "../../api/installers/Installers.api";
import Error from "../../components/Error";
import Loading from "../../components/Loading";
import { AuthContext } from "../../context/auth/AuthContext";
import Success from "../../components/Success";

const EditInstallerContainer = ({ installer, children }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const { token } = useContext(AuthContext);
  const [success, setSuccess] = useState(false);

  const onSubmit = (values, actions) => {
    setError(null);
    setLoading(true);

    let params = values;
    if (!values.profile) {
      params.profile = installer;
    }

    Request.updateInstaller(token.access, {
      ...params,
      ...params.profile,
      installer: installer.profile.id_installer,
    })
      .then((data) => onSuccess(data, actions))
      .catch((error) => onFailure(error, actions));
  };

  const onSuccess = ({ data }, actions) => {
    actions.setSubmitting(false);
    setLoading(false);
    setSuccess(true);
  };

  const onFailure = (error, actions) => {
    setError(error);
    setLoading(false);
    actions.setSubmitting(false);
  };
  const onCloseSuccesPopup = () => {
    setSuccess(null);
  };

  return (
    <>
      {error ? <Error message={error} /> : null}
      {loading ? <Loading /> : loading}
      {success ? (
        <Success
          message="Your data has been updated."
          onClose={() => onCloseSuccesPopup()}
        />
      ) : null}
      {installer ? children({ onSubmit, installer }) : null}
    </>
  );
};

export default EditInstallerContainer;
